import storage from 'store'
function isChineseString(c) {
    const reg = /^[\u4E00-\u9FA5\uf900-\ufa2d]/;
    return reg.test(c);
}

function isEnglishString(c) {
    const reg = /^[a-zA-Z]/;
    return reg.test(c);
}

function isJSONString(string) {
    try {
        JSON.parse(string);
        return true;
    } catch (e) {
        return false;
    }
}

function saveLocalStorage(key, obj) {
    if (typeof obj === 'string') {
        window.localStorage.setItem(key, obj);
    } else {
        window.localStorage.setItem(key, JSON.stringify(obj));
    }
}

function getLocalStorage(key) {
    const result = window.localStorage.getItem(key);
    if (isJSONString(result)) {
        return JSON.parse(result);
    }

    return result;
}

function throttle(fn, wait = 500, period = 1000) {
    let startTime = new Date().getTime();
    let timeout;
    return (...args) => {
        return new Promise(resolve => {
            const now = new Date().getTime();
            if (now - startTime >= period) {
                startTime = now;
                resolve(fn.apply(null, args));
            } else {
                timeout && clearTimeout(timeout);
                timeout = setTimeout(() => {
                    resolve(fn.apply(null, args));
                }, wait);
            }
        }); 
    }
}
// url解析
function parseSearchToState(search) {
    if (!search) {
        return {};
    }

    return search.substr(1).split('&').reduce((r, m) => {
        const key = m.split('=')[0];
        const value = m.split('=')[1];
        // eslin -disable-next-line
        return r[key] = decodeURIComponent(value), r;
    }, {});
}
// 生成url
function parseStateToSearch(state) {
    if (!state || typeof state !== 'object') {
        return '';
    }

    const keys = Object.keys(state);
    let search = '';
    for (let key of keys) {
        search += `${key}=${state[key]}&`;
    }

    search = search === '' ? search : `?${search.substr(0, search.length - 1)}`;
    return search;
}
function removeArray (arr, val) {
  let index = arr.indexOf(val); 
  if (index > -1) { 
    arr.splice(index, 1); 
  } 
  return arr
}

function removeEmptyAttr(obj = {}) {
  let newObj = {}
  for (const i in obj) {
    if (obj.hasOwnProperty(i)) {
      !!obj[i] && (newObj[i] = obj[i])
    }
  }
  return newObj
}

//和移动端协议  关闭当前页面
function toNum(a) {
    var a = a.toString();
    //也可以这样写 var c=a.split(/\./);
    var c = a.split('.');
    var num_place = ["", "0", "00", "000", "0000"],
        r = num_place.reverse();
    for (var i = 0; i < c.length; i++) {
        var len = c[i].length;
        c[i] = r[len] + c[i];
    }
    var res = c.join('');
    return res;
}

  function cpr_version(a, b) {
    
      var _a =toNum(a),
          _b =toNum(b);
      if (_a > _b) {
          return false;
      };
      if (_a <= _b) {
          return true
      };
  }
function coloseM(){
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    var a = "7.0.9";
    var b =storage.get('APPVersion')? storage.get('APPVersion'):'0';
    if (isiOS) {
        //  IOS 7.0.8版本以上的的
        if(storage.get('channel')=='fromYueChe'&& !!cpr_version(a, b)){
            window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.closeWebView.postMessage({});
        }else if(storage.get('channel')=='fromRuJia'){
            window.webkit && window.webkit.messageHandlers &&  window.webkit.messageHandlers.closeWebView.postMessage(null);
        }
        
    } else{
        if(storage.get('channel')=='fromYueChe'){
            window.MutualAppH5DTO && window.MutualAppH5DTO.closeWebView();
        }
        else if(storage.get('channel')=='fromRuJia'){
            window.client && window.client.close();
        }
     
    }
}


export {
    isChineseString,
    isEnglishString,
    saveLocalStorage,
    getLocalStorage,
    isJSONString,
    throttle,
    parseSearchToState,
    parseStateToSearch,
    removeArray,
    removeEmptyAttr,
    coloseM
}